<template>
  <div class="indexSlot">
    <div class="topNew">
      <span class="font1">新品上市</span>
      <span >/</span>
      <span >New</span>
    </div>
    <div class="centerNew" >
      <div class="goodItem"  v-for="(item,index) in goodList"
                    :key="index"
                   >
<img :src="item.image" alt="" class="goodImg"  @click="clickGood(item.id,0)">
      <div class="goodName">{{item.storeName}}</div>
      <div class="goodCar">
        <div style="color:red" v-if="item.price" @click="toLogin()">¥{{item.price}}/<span class="fs16  ">  {{item.unitName}}</span></div>
      <div style="color:red" v-else>待询价</div>
        <div  @click="clickGood(item.id,0)" class="carImg"></div>
      </div>
</div>

    </div>
  </div>
</template>

<script>
import {
  getProducts
} from '@/api/indexpage.js'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'
export default {
  props: { obj: Object },
  data () {
    return {
      goodList: [],
      listquery: {
        'isIntegral': 0, // 是否积分兑换商品 0否  1是
        'keyword': '', // 关键
        'news': 1, // 是否新品  0否  1是
        'priceOrder': '', // 价格排序
        'salesOrder': '', // 销量排序
        'sid': '', // 分类ID
        'type': '', // 类别 不传
        'limit': 4,
        'page': 1
      }
    }
  },
  created () {
    this.getProList()
  },
  methods: {
    toLogin(){
      const token = getToken()
      if ( !token ) {
        this.$router.push("/myLogin");
        //store.commit('setLoginVisible', true)
      }

    },
    // 新品查询
    async getProList () {
      const token = getToken()
    if(token===undefined){
      var res = await getProducts(this.listquery)
      if (res.status === 200) {
        this.goodList = res.data
        this.goodList.forEach((item, index) => {
        item.price = '登录查看';
     });
      }
    }else{
      var res = await getProducts(this.listquery)
      if (res.status === 200) {
        this.goodList = res.data
      }
    }

    },
    clickGood (id, type) {
      this.$router.push({
                path: '/productDetail',
                query: {
                productId: id,
                type: type
                }
            })
    }
  }
}
</script>

<style lang="scss">
.indexSlot {
  width: 1480px;
    margin:50px auto ;
   .topNew{
    height: 60px;
    line-height: 60px;
    background: #fff;
    font-size: 21px;
      font-weight: 500;
      color: #409EFF;
    .font1{
      margin: 0 5px 0 30px ;
      color: black;
    }
   }
   .centerNew{
    //background: ora#nge;
    display: flex;
    flex-wrap:wrap;
  justify-content:space-between;
  margin-top:20px;
    .goodItem{
      width:24%;
      font-size: 18px;
  text-align: center;
      background: #fff;
      .goodImg{
        width: 173px;
        height: 173px;
        margin-top: 20px;
        cursor: pointer;
      }
      .goodImg:hover{
        transform: scale(1.02);
}
      .goodName{
margin: 20px;
overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
      }
      .goodName:hover{
        color: #409EFF;
      }
      .goodCar{
        width: 65%;
        margin: 30px auto ;
        display: flex ;
        justify-content: space-around;
    align-content: center;
    align-items: center;
    cursor: pointer;
    .carImg{
      width: 30px;
      height: 30px;
      background: url('../../../../../static/index/itemCar.png') no-repeat;
    }
    .carImg:hover{
        background: url('../../../../../static/index/itemCar2.png') no-repeat;
      }
      }

    }
   }
}
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/newGoods.vue